// Mock data for PROBUILD MARKET LTD website

export const materials = [
  {
    id: 1,
    name: 'Premium Steel Beams',
    category: 'Steel',
    country: 'Germany',
    price: '€2,450/ton',
    certification: 'CE, ISO 9001',
    image: 'https://images.unsplash.com/photo-1605600659873-d808a13e4d2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzdGVlbHxlbnwwfHx8fDE3NTk2OTA2MTh8MA&ixlib=rb-4.1.0&q=85',
    inStock: true,
    description: 'High-grade structural steel beams for commercial construction.'
  },
  {
    id: 2,
    name: 'Reinforced Concrete Blocks',
    category: 'Concrete',
    country: 'Netherlands',
    price: '€85/m³',
    certification: 'CE, EN 206',
    image: 'https://images.unsplash.com/photo-1637241612956-b7309005288b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBtYXRlcmlhbHN8ZW58MHx8fHwxNzU5NjkwNjEyfDA&ixlib=rb-4.1.0&q=85',
    inStock: true,
    description: 'Premium concrete blocks with superior strength and durability.'
  },
  {
    id: 3,
    name: 'Thermal Insulation Panels',
    category: 'Insulation',
    country: 'Austria',
    price: '€45/m²',
    certification: 'CE, EN 13163',
    image: 'https://images.pexels.com/photos/159045/the-interior-of-the-repair-interior-design-159045.jpeg',
    inStock: true,
    description: 'Energy-efficient insulation panels for modern buildings.'
  },
  {
    id: 4,
    name: 'Architectural Glass Panels',
    category: 'Glass',
    country: 'Belgium',
    price: '€180/m²',
    certification: 'CE, EN 572',
    image: 'https://images.pexels.com/photos/46167/iron-rods-reinforcing-bars-rods-steel-bars-46167.jpeg',
    inStock: false,
    description: 'High-performance architectural glass for facades.'
  },
  {
    id: 5,
    name: 'Composite Roofing Materials',
    category: 'Roofing',
    country: 'France',
    price: '€68/m²',
    certification: 'CE, EN 544',
    image: 'https://images.unsplash.com/photo-1605600659873-d808a13e4d2a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxzdGVlbHxlbnwwfHx8fDE3NTk2OTA2MTh8MA&ixlib=rb-4.1.0&q=85',
    inStock: true,
    description: 'Weather-resistant composite materials for roofing applications.'
  },
  {
    id: 6,
    name: 'Electrical Cable Systems',
    category: 'Electrical',
    country: 'Sweden',
    price: '€12/meter',
    certification: 'CE, IEC 60502',
    image: 'https://images.unsplash.com/photo-1637241612956-b7309005288b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBtYXRlcmlhbHN8ZW58MHx8fHwxNzU5NjkwNjEyfDA&ixlib=rb-4.1.0&q=85',
    inStock: true,
    description: 'Professional-grade electrical cables for construction projects.'
  }
];

export const categories = [
  { name: 'All Materials', value: 'all', count: materials.length },
  { name: 'Steel', value: 'steel', count: 2 },
  { name: 'Concrete', value: 'concrete', count: 1 },
  { name: 'Insulation', value: 'insulation', count: 1 },
  { name: 'Glass', value: 'glass', count: 1 },
  { name: 'Electrical', value: 'electrical', count: 1 }
];

export const countries = [
  { name: 'All Countries', value: 'all' },
  { name: 'Germany', value: 'germany' },
  { name: 'Netherlands', value: 'netherlands' },
  { name: 'Austria', value: 'austria' },
  { name: 'Belgium', value: 'belgium' },
  { name: 'France', value: 'france' },
  { name: 'Sweden', value: 'sweden' }
];

export const partners = [
  {
    id: 1,
    name: 'SteelTech Industries',
    logo: 'https://via.placeholder.com/160x80/E5E7EB/6B7280?text=SteelTech',
    country: 'Germany',
    specialization: 'Steel Manufacturing'
  },
  {
    id: 2,
    name: 'EuroGlass Solutions',
    logo: 'https://via.placeholder.com/160x80/E5E7EB/6B7280?text=EuroGlass',
    country: 'Belgium',
    specialization: 'Glass & Facades'
  },
  {
    id: 3,
    name: 'Nordic Insulation Co.',
    logo: 'https://via.placeholder.com/160x80/E5E7EB/6B7280?text=Nordic',
    country: 'Sweden',
    specialization: 'Thermal Solutions'
  },
  {
    id: 4,
    name: 'Alpine Concrete',
    logo: 'https://via.placeholder.com/160x80/E5E7EB/6B7280?text=Alpine',
    country: 'Austria',
    specialization: 'Concrete Products'
  },
  {
    id: 5,
    name: 'Dutch Build Systems',
    logo: 'https://via.placeholder.com/160x80/E5E7EB/6B7280?text=Dutch+Build',
    country: 'Netherlands',
    specialization: 'Engineering Solutions'
  },
  {
    id: 6,
    name: 'French Electrical Corp',
    logo: 'https://via.placeholder.com/160x80/E5E7EB/6B7280?text=French+Elect',
    country: 'France',
    specialization: 'Electrical Systems'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Marcus Schmidt',
    company: 'Berlin Construction Group',
    role: 'Project Director',
    content: 'PROBUILD MARKET has transformed how we source materials. The transparency and quality assurance are exceptional.',
    avatar: 'https://via.placeholder.com/64x64/E5E7EB/6B7280?text=MS'
  },
  {
    id: 2,
    name: 'Sarah Johnson',
    company: 'Amsterdam Developers',
    role: 'Procurement Manager',
    content: 'The B2B platform streamlined our entire supply chain. We reduced costs by 15% while improving delivery times.',
    avatar: 'https://via.placeholder.com/64x64/E5E7EB/6B7280?text=SJ'
  },
  {
    id: 3,
    name: 'Giuseppe Rossi',
    company: 'Mediterranean Builders',
    role: 'CEO',
    content: 'Outstanding service and quality materials. The logistics management saved us countless hours of coordination.',
    avatar: 'https://via.placeholder.com/64x64/E5E7EB/6B7280?text=GR'
  }
];

export const stats = [
  { label: 'Projects Completed', value: '2,500+' },
  { label: 'Partner Companies', value: '150+' },
  { label: 'Countries Served', value: '25+' },
  { label: 'Materials Catalog', value: '10,000+' }
];